import styles from './AutoResaleReturnsModalWindow.module.scss';
import Box from '@components/Box';
import FormErrorMessage from '@components/FormErrorMessage';
import InfoIcon from '@components/../assets/icons/info-grey-18.svg';
import parse from 'html-react-parser';
import PlacingOrderButtons from '@components/PlacingOrderButtons';
import PlacingOrderHeader from '@components/PlacingOrderHeader';
import Switch from '@components/new/Switch';
import { ButtonType } from '@components/Button';
import { Column, Grid, Row } from '@components/Grid';
import { createSumFromObject } from '@utils/formatValues';
import { IAutoResaleReturnsModalWindowProps } from './types';
import { sendAutoResaleReturnsData, TAmountWithCurrency } from '@api/apiClient/returns';
import { Text, TextSize } from '@components/Text';
import { Tooltip } from '@components/new/Tooltip';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';

const AutoResaleReturnsModalWindow: React.FC<IAutoResaleReturnsModalWindowProps> = (props: IAutoResaleReturnsModalWindowProps): React.ReactElement => {
  const { autoResaleData, handlerSetIsOpenAutoResaleWindow, handlerRefetchData } = props;

  const [autoResaleEnabled, setAutoResaleEnabled] = useState<boolean>(false);
  const [currentPrice, setCurrentPrice] = useState<TAmountWithCurrency | undefined>(undefined);

  const { t } = useTranslation();

  const {
    error: errorSendAutoResaleData,
    isError: isErrorSendAutoResaleData,
    isLoading: isLoadingSendAutoResaleData,
    mutate: mutateSendAutoResaleData
  } = useMutation({
    mutationFn: sendAutoResaleReturnsData,
    onSuccess() {
      handlerRefetchData();
      handlerSetIsOpenAutoResaleWindow(false);
    }
  });

  useEffect(() => {
    const { enabled, resalePrice } = autoResaleData;
    setAutoResaleEnabled(enabled);
    setCurrentPrice(resalePrice);
  }, [autoResaleData]);

  const handlerSendAutoResaleData = () => {
    mutateSendAutoResaleData({ enabled: autoResaleEnabled });
  };

  return (
      <Grid>
        <PlacingOrderHeader title={t('autoResaleReturnsModalWindow.title')}/>
        <Row>
          <Column phone={12}>
            <Box mb={5}>
              <Text size={TextSize.S}>
                {parse(t('autoResaleReturnsModalWindow.description', { price: createSumFromObject(currentPrice!) }))}
              </Text>
            </Box>
          </Column>
        </Row>
        {/*<Row>*/}
        {/*  <Column phone={12}>*/}
        {/*    <Box mb={5}>*/}
        {/*      <div className={styles.info}>*/}
        {/*        <div className={styles.infoText}>*/}
        {/*          <Text*/}
        {/*              size={TextSize.S}*/}
        {/*              weight={TextWeight.BOLD}*/}
        {/*          >*/}
        {/*            {t('autoResaleReturnsModalWindow.infoTitle')}*/}
        {/*          </Text>*/}
        {/*          <Text size={TextSize.S}>*/}
        {/*            {parse(t('autoResaleReturnsModalWindow.infoText'))}*/}
        {/*          </Text>*/}
        {/*        </div>*/}
        {/*        <Button*/}
        {/*            onClick={() => navigate('/profile?tab=storeTab')}*/}
        {/*            title={t('autoResaleReturnsModalWindow.infoBtn')}*/}
        {/*            type={ButtonType.GOLD_SKELETON}*/}
        {/*        />*/}
        {/*      </div>*/}
        {/*    </Box>*/}
        {/*  </Column>*/}
        {/*</Row>*/}
        <div className={styles.row}>
          <Switch
            checked={autoResaleEnabled}
            onChange={() => setAutoResaleEnabled(!autoResaleEnabled)}
            title={t('autoResaleReturnsModalWindow.check')}
          />
          <Tooltip
              action={
                <img
                    className={styles.icon}
                    alt="Info"
                    src={InfoIcon}
                />
              }
              position="right"
              text={t('autoResaleReturnsModalWindow.tooltipText')}
          />
        </div>
        <PlacingOrderButtons
            buttons={[
              {
                action: () => handlerSetIsOpenAutoResaleWindow(false),
                disabled: isLoadingSendAutoResaleData,
                text: t('autoResaleReturnsModalWindow.cancel'),
                type: ButtonType.SKELETON
              }, {
                action: handlerSendAutoResaleData,
                disabled: isLoadingSendAutoResaleData,
                text: t('autoResaleReturnsModalWindow.save'),
                type: ButtonType.BLOCK
              }
            ]}
        />
        {isErrorSendAutoResaleData && <FormErrorMessage error={errorSendAutoResaleData}/>}
      </Grid>
  );
};

export default AutoResaleReturnsModalWindow;
